<template>
  <div class="wrapper">
    <div class="wrapper-header"></div>
    <div class="wrapper-body">
      <div class="left-panel">
        <div class="left-panel-search">
          <b-input placeholder="Search partners..." type="search" icon-pack="fas" icon="search"
            v-model="search_query" expanded />
        </div>
        <div class="channel-item" v-for="(item, index) in filtered_partner_users" :key="index" :class="{
          active: selected_partner && item.id == selected_partner.id,
        }" @click="selectPartner(item)">
          <div class="channel-profile">
            <img :src="`${$store.state.ASSETS_BASE_URL}/assets/uploaded/${item.profile_image}`" />
          </div>
          <div class="channel-info">
            <div class="channel-name">{{ item.first_name }} {{ item.last_name }}</div>
            <div class="channel-subscribers">{{ item.phone || item.email }}</div>
          </div>
        </div>
        <widgetNotfound v-if="!loading_partners && filtered_partner_users.length === 0"
          title="No partners found" subtitle="Try a different search term">
        </widgetNotfound>
      </div>
      <div class="rigth-panel" v-if="selected_partner">
        <div class="rigth-panel-header">
          <div class="tabs-widget">
            <span @click="selected_partner = null">Close</span>
            <div class="tab-item" :class="{ active: selected_tab == 'dashboard' }" @click="switchTab('dashboard')">
              DASHBOARD
            </div>
            <div class="h-spacer"></div>
            <div class="tab-item" :class="{ active: selected_tab == 'streaming' }" @click="switchTab('streaming')">
              STREAMING
            </div>
            <div class="h-spacer"></div>
            <div class="tab-item" :class="{ active: selected_tab == 'events' }" @click="switchTab('events')">
              EVENTS
            </div>
            <div class="h-spacer"></div>
            <div class="tab-item" :class="{ active: selected_tab == 'voting' }" @click="switchTab('voting')">
              VOTING
            </div>
          </div>
        </div>
        <div class="rigth-panel-body">
          <DashboardTab v-if="selected_tab == 'dashboard'" :partner="selected_partner" :channel="selected_channel">
          </DashboardTab>
          <StreamingTab v-if="selected_tab == 'streaming' && selected_channel" :channel="selected_channel">
          </StreamingTab>
          <EventsTab v-if="selected_tab == 'events'" :partner="selected_partner"></EventsTab>
          <VotingTab v-if="selected_tab == 'voting' && selected_channel" :channel="selected_channel"></VotingTab>
          <widgetNotfound v-if="(selected_tab == 'streaming' || selected_tab == 'voting') && !selected_channel"
            title="Channel not found" subtitle="No channel is linked to this partner">
          </widgetNotfound>
        </div>
      </div>
      <div v-else class="rigth-panel no-data-panel">
        <div class="rigth-panel-body">
          <widgetNotfound title="Partner not selected" subtitle="Please select partner from the left panel">
          </widgetNotfound>
        </div>
      </div>

    </div>
    <div class="wrapper-footer"></div>
  </div>
</template>

<script>
import DashboardTab from "./components/DashboardTab.vue";
import StreamingTab from "./components/StreamingTab.vue";
import EventsTab from "./components/EventsTab.vue";
import VotingTab from "./components/VotingTab.vue"
export default {
  components: {
    DashboardTab,
    StreamingTab,
    EventsTab,
    VotingTab
  },
  data: () => ({
    selected_tab: "dashboard",
    partner_users: [],
    search_query: "",
    loading_partners: false,
    channels: [],
    selected_partner: null,
    selected_channel: null,
  }),
  watch: {},
  mounted() {
    let vm = this;
    vm.getPartnerUsers();
    vm.getAllChannels();
  },
  computed: {
    filtered_partner_users() {
      const query = this.search_query.trim().toLowerCase();
      if (!query) return this.partner_users;

      return this.partner_users.filter((user) => {
        const fullName = `${user.first_name || ""} ${user.last_name || ""}`.toLowerCase();
        const phone = (user.phone || "").toLowerCase();
        const email = (user.email || "").toLowerCase();
        return fullName.includes(query) || phone.includes(query) || email.includes(query);
      });
    },
  },
  methods: {
    selectPartner(partner) {
      this.selected_partner = partner;
      this.selected_channel = this.channels.find((channel) => channel.user_id == partner.id) || null;
      this.selected_tab = "dashboard";
    },
    getPartnerUsers() {
      let vm = this;
      vm.loading_partners = true;
      vm.$store
        .dispatch("ADMIN_USER_GET_USERS")
        .then((response) => {
          vm.loading_partners = false;
          vm.partner_users = response.data.return.filter(
            (user) => user.account_type === "streamer"
          );
        })
        .catch(() => {
          vm.loading_partners = false;
        });
    },
    getAllChannels() {
      let vm = this;
      vm.$store
        .dispatch("CHANNEL_GET_ALL")
        .then((response) => {
          vm.channels = response.data.return;
          if (vm.selected_partner) {
            vm.selected_channel = vm.channels.find(
              (channel) => channel.user_id == vm.selected_partner.id
            ) || null;
          }
        })
        .catch(() => { });
    },
    switchTab(type) {
      let vm = this;
      vm.selected_tab = type;
    },
  },
};
</script>
<style lang="scss" scoped>
.wrapper {
  padding: 0px;
  display: flex;
  flex-direction: column;
  height: 100%;

  .wrapper-header {
    height: 0px;
  }

  .wrapper-body {
    height: calc(100% - 0px);
    display: flex;
    position: relative;

    .left-panel {
      overflow-y: auto;
      height: 100%;
      width: 350px;
      display: flex;
      flex-direction: column;

      .left-panel-search {
        padding: 12px;
        border-bottom: 1px solid #e5e5e5;
        background: #fff;
        position: sticky;
        top: 0;
        z-index: 1;
      }

      @media (max-width: 760px) {
        width: 40%;
      }

      @media (max-width: 579px) {
        width: 100%;
      }

      .channel-item {
        display: flex;
        padding: 20px;
        align-items: center;
        border-bottom: 1px solid #e5e5e5;
        cursor: pointer;

        &.active {
          background-color: #ffff;
        }

        .channel-profile {
          width: 50px;
          height: 50px;
          border-radius: 50%;
          overflow: hidden;

          img {
            width: 100%;
            height: 100%;
            object-fit: cover;
          }
        }

        .channel-info {
          margin-left: 10px;

          .channel-name {
            font-size: 18px;
            font-weight: 600;
          }

          .channel-subscribers {
            font-size: 14px;
            color: #999;
          }
        }
      }
    }

    .rigth-panel {
      width: calc(100% - 350px);
      height: 100%;
      background: #fff;
      border-left: 1px solid #ddd;
      display: flex;
      flex-direction: column;

      @media (max-width: 760px) {
        width: 60%;
      }

      @media (max-width: 579px) {
        width: 80%;
        position: absolute;
        background: white;
        top: 0;
        z-index: 999;
        top: 0;
        right: 0px;
        transition: .5s;
        box-shadow: -10px 10px 10px rgba(0, 0, 0, 0.089);

        &.no-data-panel {
          display: none;
        }
      }

      .rigth-panel-header {
        width: 100%;
        height: 60px;
        background: #fff;
        display: flex;
        align-items: center;
        justify-content: space-between;
        border-bottom: 1px solid #ddd;
        padding: 0px 0px;
        overflow-x: auto;

        .tabs-widget {
          display: flex;
          align-items: flex-end;
          margin-right: 15px;
          align-items: center;

          span {
            font-size: 18px;
            font-weight: 600;
            color: red;
            cursor: pointer;
            display: flex;
            margin: 0px 15px 0 10px;
            display: none;

            @media(max-width: 579px) {
              display: block;
            }
          }

          .h-spacer {
            margin-right: 20px;
          }

          .tab-item {
            cursor: pointer;
            padding: 16px 10px;
            border-bottom: 3px solid transparent;
            white-space: nowrap;

            &.active {
              color: var(--wecodefy-secondary-color, #9fc953);
              border-bottom: 3px solid var(--wecodefy-secondary-color, #9fc953);
            }
          }
        }

        .tab-options {
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding: 0px 10px;

          .h-spacer {
            margin-right: 10px;
          }
        }
      }

      .rigth-panel-body {
        flex: 1;
        overflow-y: auto;
      }
    }
  }

  .wrapper-footer {
    height: 0px;
    background: #fff;
    display: flex;
    justify-content: center;
    flex-direction: column;
    padding: 0px 10px;
    border-top: 1px solid #ddd;
  }
}
</style>
